import { createGetEndpoint } from '@sonar-software/sonar-http';
import { featureFlagMetadata } from '../../@types';

export type getAdminFeatureFlagsAllResponse = {
	totalCustomerCount: number
	featureFlags: Array<featureFlagMetadata>
};

export const getAdminFeatureFlagsAll = createGetEndpoint<void, getAdminFeatureFlagsAllResponse>(
	'/api/v3/core/feature-flags'
);
